module.exports = __webpack_public_path__ + "static/media/gfidBg.7aa750e4.jpg";